/**
 * LINE連携コードの読み込み結果から、次の動きを決める（指示書 A-1③-1、A-22）。
 *
 * 以前は、GET /api/line-link-codes が失敗（HTTP 500・不正な応答・通信例外）しても、
 * 連携コードを自動で新規発行していた。発行API（POST）は既存のコードを削除して作り直すため、
 * 使用中のコードが差し替わり、画面には「未連携」と表示されることがあった。
 * 発行するのは、正常に取得できて、コードが無いと確認できたときだけにする。失敗時は読み込みだけをやり直す。
 *
 * @param {{ ok: boolean, json: any, learnerId?: string|null }} p
 * @returns {{ kind: 'error' } | { kind: 'apply', generate: 'none'|'child'|'all' }}
 */
export function decideLinkCodesLoad({ ok, json, learnerId }) {
  if (!ok) return { kind: 'error' }
  if (!json || typeof json !== 'object' || json.success !== true || !json.data || typeof json.data !== 'object') {
    return { kind: 'error' }
  }
  const d = json.data
  if (learnerId) {
    // learner 単位: child だけ不足していたら child のみ発行（親・本人は維持）
    return { kind: 'apply', generate: d.childCode ? 'none' : 'child' }
  }
  // 従来（learnerId 無し）: 親・子のどちらかが不足していたらまとめて発行
  return { kind: 'apply', generate: d.parentCode && d.childCode ? 'none' : 'all' }
}
